export const AUTH_CONSTANTS = {
    APPLY_CREATE_NEW_ACCOUNT: 'APPLY FOR A NEW CREATOR ACCOUNT',
    STEP_1_4: 'Step 1 of 4',
    PERSONAL_INFORMATION: 'PERSONAL INFORMATION',
    SELECT_INTERESTS: 'What are your Interests? (Select as many as you like):',
    CONTENT_TYPE_REQUIRED: '* Content type is required',
    HAVE_ACCOUNT: 'Already have an account?',
    GO_TO_PREFERENCE: 'go to Preferences > Become a Creator on TopFan',
    SIGN_IN: 'Sign In',
    CREATING_ACCOUNT: 'By creating an account, you agree to our',
    CONTINUE: 'Continue',
    WLS_SOCIAL_TAKEN_TO: 'You will now be taken to',
    WLS_SOCIAL_SIGN_IN: 'to sign in via our authentication partner',
    WLS_SOCIAL_SIGN_UP: 'to sign up via our authentication partner',
    TOPFAN: 'TopFan',
    SUCCESS: 'success',
    STEP_2_4: 'Step 2 of 4',
    STEP_3_4: 'Step 3 of 4',
    STEP_4_4: 'Step 4 of 4',
    STEP_2_3: 'Step 2 of 3',
    CONTINUE_UPPER: 'CONTINUE',
    CONTENT_CREATOR_SETUP: 'Content Creator Setup',
    CONFIRM_CREATOR_SELECTION: 'Confirm Your Creator Type Selection',
    RESEND_CODE: 'Resend Code',
    VERIFY: 'Verify',
    VERIFY_YOUR_IDENTITY: 'VERIFY YOUR IDENTITY',
    CHOOSE_YOUR_CREATOR_TYPE: 'CHOOSE YOUR CREATOR TYPE',
    ACCOUNT_INFORMATION: 'ACCOUNT INFORMATION',
    CREATOR_INFORMATION: 'Profile Avatar* & Banner Image*',
    CLICK_HERE: 'Click Here',
    IF_YOU_ARE_A_FAN: 'If you are a Fan, ',
    ARE_YOU_A_CREATOR: 'Are you a Creator? ',
    GET_STARTED: 'Get Started',
    SIGN_UP: 'SIGN UP',
    SIGN_IN_CAPS: 'SIGN IN',
    SIGN_IN_HEADING: 'Sign In with your credentials',
    SIGN_IN_SUBHEADING: 'Sign in with Google or Apple, or enter your details below',
    SIGN_IN_GOOGLE: 'Sign in with Google',
    SIGN_IN_APPLE: 'Sign in with Apple',
    SIGN_UP_GOOGLE: 'Sign up with Google',
    SIGN_UP_APPLE: 'Sign up with Apple',
    SIGN_UP_SUBHEADING: 'Sign up with Google or Apple, or fill in your details below.',
    CREATE_FAN_ACCOUNT: 'CREATE YOUR FAN ACCOUNT',
    SETUP_YOUR_PROFILE: 'Setup Your Profile',
    YOUR_PROFILE_IMAGE: 'Profile Avatar*',
    COVER_IMAGE: 'Banner Image*',
    CLICK_TO_UPLOAD_COVER: 'Click to upload cover image',
    COVER_IMAGE_HINT: 'Recommended: 800 × 400px • JPG, PNG',
    CREATE_AVATAR_WITH_AI: 'Create Avatar With AI',
    UPLOAD_IMAGE: 'Upload Image',
    REMOVE_IMAGE: 'Remove Image',
    REMOVE_BANNER_IMAGE: 'Remove banner image',
    SAVE_AND_CONTINUE: 'Save And Continue',
    FIRST_NAME_PLACEHOLDER: 'Enter your first name',
    LAST_NAME_PLACEHOLDER: 'Enter your last name',
    BIRTHDATE_PLACEHOLDER: 'Birthdate',
    GENERAL_LOCATION_PLACEHOLDER: 'Enter Your General Location',
    MOBILE_VERIFICATION: 'Mobile Number for Verification',
    PHONE_PLACEHOLDER: 'Phone Number',
    TERMS_CHECKBOX: 'By creating an account, you agree to our',
    TERMS_OF_SERVICE: 'terms and services',
    PRIVACY_POLICY: 'privacy policy',
    PROFILE_PLACEHOLDER: 'assets/images/svg/ic-profile.svg',
    FORGOT_PASSWORD: 'Forgot your password?',
    KEEP_SIGNED_IN: 'Keep me signed in',
    EMAIL_PLACEHOLDER: 'Email Address',
    PASSWORD_PLACEHOLDER: 'Password',
    NO_ACCOUNT: 'Do not have an account?',
    CREATE_ACCOUNT: 'Create Account',
    CREATE_NEW_ACCOUNT: 'Create New Account',
    CREATE_NEW_FAN_ACCOUNT: 'CREATE NEW FAN ACCOUNT',
    BACK: 'Back',
    STEP_1_3: 'Step 1 of 3',
    STEP_3_3: 'Step 3 of 3',
    STEP_1_2: 'Step 1 of 2',
    STEP_2_2: 'Step 2 of 2',
    CREATOR_FLOW: 'creator_flow',
    CREATOR_SIGNUP_NOTE: 'Note: Enter your Legal Name on this Step, you will add your Publicly Displayed Name on Step 2.',
    CREATOR_SIGNUP_HINT: 'If you are an organization, band, team, etc. please register as the legal representative at this step. On Step 2, you can enter the Publicly Displayed Name of the organization that fans will view you as.',
    PROFILE_AVATAR_BANNER_IMAGE: 'Profile Avatar* & Banner Image',
    SET_COMMUNITY_AVATAR_PROFILE_IMAGE: 'Set your Community Avatar* and Profile Image',
    EXPLORE_FEATURES: 'Explore Features',
    EXPLORE_COMPARISON: 'Compare',
    Features: 'Features',
    COMPARE: 'Compare',
    COMMUNITY_VERTICALS: 'Community Verticals',
    PLATFORM: 'Platform',
    CONTINUE_GOOGLE: 'Continue with Google',
    CONTINUE_APPLE: 'Continue with Apple',
    GOOGLE_LOGO: 'assets/images/svg/google-logo.svg',
    APPLE_LOGO: 'assets/images/svg/apple-logo.svg',
    GOOGLE: 'Google',
    APPLE: 'Apple',
    OR: 'or',
    COMPLETE_SIGNUP: 'COMPLETE SIGNUP',
    SOCIAL_SIGNUP: 'social_signup',
    SOCIAL_CREATOR_SIGNUP: 'social_creator_signup',
    SOCIAL_SETUP: 'social_setup',
    SOCIAL_REFER: 'social_refer',
    SOCIAL_LINK: 'social_link',
    SOCIAL_GATE: 'social_auth_gate',
    SOCIAL_RESUME_KEY: 'social_resume_key',
    CONNECTED_ACCOUNTS: 'Sign-in Methods',
    CONNECT_GOOGLE: 'Connect',
    CONNECT_APPLE: 'Connect',
    DISCONNECT: 'Disconnect',
    DISCONNECT_CONFIRM_TITLE: 'Disconnect',
    DISCONNECT_CONFIRM: 'Are you sure you want to disconnect {{provider}}?',
    SET_PASSWORD: 'Set Password',
    USE_SOCIAL_LOGIN: 'USE_SOCIAL_LOGIN',
    LOGIN: 'LOGIN',
    COMPLETE_SIGNUP_STEP: 'COMPLETE_SIGNUP',
    DUMMY_EMAIL: 'Please enter a valid email address.'
}

export const PRO_HEADER_NAV = {
    VERTICALS: [
        { label: 'Music & Entertainment', route: '/apps/music-band-fan-club/' },
        { label: 'Film & Television', route: '/apps/mobile-apps-film-television/' },
        { label: 'Sports Team Fan Club', route: '/apps/sports-teams-nil-collectives-membership' },
        { label: 'Associations & Interest Topics', route: '/apps/associations-community-platform/' },
        { label: 'Conferences & Festivals', route: '/apps/virtual-conferences/' },
        { label: 'Facebook Groups', route: '/apps/facebook-group-alternative/' },
        { label: 'Patreon Creators', route: '/apps/content-creators-patreon-alternative/' },
        { label: 'View All Communities', route: '/apps' }
    ],
    PLATFORMS: [
        { label: 'Fan Relationship Management', route: '/fan-relationship-management/' },
        { label: 'Direct to Fan', route: '/direct-to-fan' },
        { label: 'Challenge Marketing', route: '/challenge-marketing' },
        { label: 'Fan Engagement', route: '/fan-interactivity' },
        { label: 'Mobile Web', route: '/mobile-web' }
    ]
} as const;

export const TARGET_ORIGIN = 're-captcha';
export const RECAPTCHA_POST_MESSAGE = {
    BUBBLE_OPENED: 'bubble-opened',
    BUBBLE_CLOSED: 'bubble-closed',
    CAPTCHA_COMPLETED: 'captcha-completed'
}